export const COUNTRIES = [
  { code: "CA", name: "Canada", currency: "CAD" },

  // XAF
  { code: "CM", name: "Cameroun", currency: "XAF" },
  { code: "CF", name: "République centrafricaine", currency: "XAF" },
  { code: "TD", name: "Tchad", currency: "XAF" },
  { code: "CG", name: "Congo-Brazzaville", currency: "XAF" },
  { code: "GA", name: "Gabon", currency: "XAF" },
  { code: "GQ", name: "Guinée équatoriale", currency: "XAF" },
 
  // XOF
  { code: "BJ", name: "Bénin", currency: "XOF" },
  { code: "BF", name: "Burkina Faso", currency: "XOF" },
  { code: "CI", name: "Côte d'Ivoire", currency: "XOF" },
  { code: "GW", name: "Guinée-Bissau", currency: "XOF" },
  { code: "ML", name: "Mali", currency: "XOF" },
  { code: "NE", name: "Niger", currency: "XOF" },
  { code: "SN", name: "Sénégal", currency: "XOF" },
  { code: "TG", name: "Togo", currency: "XOF" },

  // Spécifiques
  { code: "CD", name: "République démocratique du Congo", currency: "CDF" },
  { code: "NG", name: "Nigéria", currency: "NGN" },
  { code: "GH", name: "Ghana", currency: "GHS" },
];